(function () {
  function openDlg(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) {} }
    else { dlg.setAttribute('open', ''); }
  }
  function bind(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-co-open]').forEach(function (btn) {
      if (btn.dataset.coBound) return;
      btn.dataset.coBound = '1';
      var dlg = document.getElementById(btn.getAttribute('data-co-open'));
      if (!dlg) return;
      btn.addEventListener('click', function () { openDlg(dlg); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });
    scope.querySelectorAll('[data-co-autoopen]').forEach(function (marker) {
      openDlg(marker.closest('dialog'));
    });
  }
  bind();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
